export default {
  title: 'inspi-packaged viewer basic',
}
